const content = {
    CURRENT_EVP: "Shannon Shams",
    EXTERNAL_VICE_PRESIDENT: "External Vice President",
     CURRENT_TAD: "Carlee Lincoln",
    TRANSFER_AFFAIRS_DIRECTOR: "Transfer Affairs Director",
    WELCOME_LETTER: [`
                 Dear prospective RSSer,
                 `,
                 `
                 Congratulations on being accepted to UCLA and receiving the Regents Scholarship! We are so excited to welcome you to our annual Overnight Stay Program (OSP)!
                 `,
                 `
                 OSP is the best place to discover and experience what UCLA and RSS has in store for you. Along the way, you’ll bond with other prospective students/current RSSers and even meet your lifelong friends! 
                 `,
                 `
                 I hope you guys will have an amazing time at OSP, and I can’t wait to meet all of you here!
                 `
                ],
    WELCOME_LETTER2: [`
                 Dear prospective RSS transfers,
                 `,
                 `
                 Congratulations on your acceptance to UCLA and on receiving the prestigious Regents Scholarship! Your application stood out from the thousands of others, and to honor your acceptance, the transfer committee and I are excited to host the very first Transfer Welcome Reception (TWR). 
                 `,
                 `     
                 TWR will be a one-night overnight stay for incoming transfers to experience a snippet of UCLA life and meet current and new RSS. We will be hosting a 3-day Zoom panel to get more information about RSS or if you can’t join in person. We will be hosting the overnight from May 15th to 16th, and the UCLA Transfer Day is May 16th. Either through virtual, the overnight stay, or joining in on Bruin Day, please come out to get a feel for UCLA life. 
                 `,
                 `
                 Hope to see y'all soon!
                 `
                ],
    OSP: "Overnight Stay Program",
    TWR: "Transfer Welcome Week",
    WELCOME_BLURB: "Welcome to UCLA! OSP is an opportunity to get to know the people you'll be spending time with possibly for the next four years! Meet the coordinators, current students, and other prospective students as you get a taste of life at UCLA!",
    

}

export default content;
